export default __webpack_public_path__ + "static/media/hht1_ep1_minisitcom_02.1ad427a3.png";